import { motion } from 'motion/react'

import { FC, PropsWithChildren, useEffect, useRef } from 'react'

import { useReferencesPanelScrollContainer, useReferencesPanelScrollTarget } from 'stores/useActiveMessageAndReferenceStore'
import { MessageReference } from 'types/Api'

import { scrollToReference } from '../utils/scrollToReference'

const REFERENCES_PANEL_HEADER_OFFSET = 50

type Props = PropsWithChildren & {
  messageId: string
  reference: MessageReference
}

export const ReferenceScrollWrapper: FC<Props> = ({ children, messageId, reference }) => {
  const referencesScrollContainer = useReferencesPanelScrollContainer(messageId)
  const referencesPanelScrollTarget = useReferencesPanelScrollTarget()

  const referenceRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!referencesScrollContainer) return
    if (!referencesPanelScrollTarget) return
    if (!referenceRef.current) return

    const isReferencePanelScrollTarget
      = referencesPanelScrollTarget.messageId === messageId
        && referencesPanelScrollTarget.referenceId === reference.refId

    if (!isReferencePanelScrollTarget) return

    referencesScrollContainer.closest('div.sticky')?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    })

    const scrollContainerRect = referencesScrollContainer.getBoundingClientRect()
    const referenceRect = referenceRef.current.getBoundingClientRect()

    const offset = referenceRect.top - scrollContainerRect.top + referencesScrollContainer.scrollTop - REFERENCES_PANEL_HEADER_OFFSET

    scrollToReference(referencesScrollContainer, offset, 500)
  }, [referencesScrollContainer, referencesPanelScrollTarget, messageId, reference.refId])

  return (
    <motion.li className="group m-0 flex w-full items-start justify-between print:-m-6">
      <div
        className="flex w-full rounded-lg px-2 py-1"
        ref={referenceRef}
      >
        {children}
      </div>
    </motion.li>
  )
}
